import { useCallback, useRef, useState } from 'react';
import type { PresentationSession } from '../types';

/**
 * Sessiestatus voor de live-pagina's, met een ref die synchroon meebeweegt.
 * Nodig omdat SSE-events kort na elkaar kunnen binnenkomen vóórdat React
 * opnieuw heeft gerenderd: de gat-detectie (eventRevealsMissedState) en de
 * oud-event-controle (eventIsStale) moeten dan tegen de nieuwste toestand
 * vergelijken, niet tegen die van de vorige render -- anders ziet een
 * gewone opeenvolgende versie er ten onrechte uit als een gemist event.
 */
export default function useLiveSessionState(initial: () => PresentationSession | null) {
  const [session, setSession] = useState<PresentationSession | null>(initial);
  const sessionRef = useRef<PresentationSession | null>(session);

  const updateSession = useCallback((updater: (prev: PresentationSession | null) => PresentationSession | null) => {
    const next = updater(sessionRef.current);
    if (next === sessionRef.current) return;
    sessionRef.current = next;
    setSession(next);
  }, []);

  return { session, sessionRef, updateSession };
}
